// Qué tarjetas enseña el tablero, y en qué orden.
//
// ESTÁ APARTE DEL COMPONENTE por dos razones, y las dos importan:
//
//   · Decidir qué NO se enseña es una regla de producto, no una línea de
//     maquetación, y se prueba como tal.
//   · El lint del proyecto no deja exportar funciones desde un archivo de
//     componentes (rompe el refresco en caliente), y tenía razón: esto no
//     es una pieza de pantalla.

// Orden en pantalla: primero lo que reclama acción, después lo
// informativo. «Terminales mudas» va arriba con lo urgente y «cuántas
// hay» abajo con lo informativo: saber que hay ocho no despierta a
// nadie; saber que tres llevan una hora calladas, sí.
export const ORDEN = [
  'aprobaciones_pendientes', 'alertas_sin_revisar', 'discrepancias_sin_ajustar',
  'sku_bajo_minimo', 'productos_sin_costo', 'items_en_cuarentena',
  'terminales_mudas',
  'solicitudes_borrado_pendientes', 'conteos_abiertos', 'movimientos_24h',
  'terminales',
  'notificaciones_no_leidas', 'salidas_ultimos_30_dias', 'ventas_ultimos_30_dias',
  'mis_solicitudes_pendientes', 'renglones_por_contar',
  'valor_inventario_total', 'capital_inmovilizado',
  'merma_periodo_valor', 'merma_periodo_unidades',
];

/** Qué tarjetas se pintan, dado lo que contestó el servidor.
 *
 *  SIN NINGUNA TERMINAL, LAS DOS TARJETAS SOBRAN · TC-29. Un
 *  «Terminales mudas: 0» en una empresa que no ha colgado ninguna es
 *  ruido, y el ruido es cómo se aprende a no mirar un tablero. En cuanto
 *  se conecta la primera, las dos aparecen solas.
 *
 *  `undefined` NO ES CERO: por debajo de ENCARGADO el tablero devuelve
 *  solo tareas y estas claves ni vienen. */
export function clavesDelTablero(valores) {
  return ORDEN
    .filter((k) => valores[k] !== undefined)
    .filter((k) => !k.startsWith('terminales') || Number(valores.terminales) > 0);
}
